import React, { useRef, useEffect } from "react"
// import Quill from "quill"
import Loadable from "@loadable/component"
import "react-quill/dist/quill.snow.css"
import Delta from "quill-delta"

// const Delta = Quill.import("delta")

const ReactQuill = Loadable(() => import("react-quill"))

/**
 * Blacklisted html attributes to be removed from user paste, prevents unwanted formatting
 */
const blacklistedAttributes = ["color", "background", "font", "size", "indent", "script", "image", "video"] // Add any attributes you want to blacklist

/**
 * Custom Quill settings for curriculum editor, header options and paste cleaning
 */
const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    ["blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    [{ align: [] }],
    ["clean"], // Remove formatting button
  ],
  clipboard: {
    matchers: [
      [
        "span",
        (node, delta) => {
          const cleaned = new Delta()
          delta.ops.forEach((op) => {
            if (op.attributes) {
              const filteredAttributes = Object.keys(op.attributes).reduce((acc, key) => {
                if (!blacklistedAttributes.includes(key)) {
                  acc[key] = op.attributes[key]
                }
                return acc
              }, {})
              cleaned.insert(op.insert, filteredAttributes)
            } else {
              cleaned.insert(op.insert)
            }
          })
          return cleaned
        },
      ],
    ],
  },
  keyboard: {
    bindings: {
      // Disable auto-list (numbered and bulleted) on space
      "list autofill": {
        key: " ",
        collapsed: true,
        prefix: /^(\s*)(\d+\.|\d+\)|[a-zA-Z]\.|[a-zA-Z]\))$/,
        handler: () => true, // Prevent Quill's default handler
      },
      list: false,
    },
  },
}

/**
 * CurriculumQuill component wrapper for ReactQuill, uses standardized modules and formats
 * @param {Object} props - Component properties
 * @param {string} props.value - Current value of the editor
 * @param {Function} props.onChange - Callback function to handle value changes
 * @param {Object} props.style - Custom styles for the editor
 * @param {string} props.placeholder - Placeholder text for the editor
 * @param {string} props.configType - Configuration type
 */
const CurriculumQuill = ({ value, onChange, style, placeholder, configType }) => {
  const quillRef = useRef(null)

  const handleFocus = () => {
    switch (configType) {
      case "COMPLETION_HEADING":
        if (quillRef.current) {
          const quill = quillRef.current.getEditor()
          quill.format("align", "center")
          quill.format("bold", true)
          quill.format("header", 2) // Set H2
        }
    }
  }

  return (
    <ReactQuill
      ref={quillRef}
      value={value}
      onChange={onChange}
      modules={modules}
      style={style}
      placeholder={placeholder}
      formats={["header", "bold", "italic", "underline", "strike", "blockquote", "list", "bullet", "link", "align"]}
      onFocus={handleFocus}
    />
  )
}

export default CurriculumQuill
